/************************************** THIRD-PARTY IMPORTS ***************************************/
import React from 'react';
import {inject} from 'mobx-react';

/**************************************** PROJECT MODULES *****************************************/
import {ChangeLanguageButtonView} from './change-language-button-view';
import {translate} from '@canimmunize/core-imports';
import {getLangFromUrlPathname} from 'mad-utils/lib/react';

/**************************************** TYPE DEFINITIONS ****************************************/
interface ChangeLanguageButtonContainerProps {}

/********************************************* EXPORT *********************************************/
/**
 *  Change language button in footer (pre-login)
 */
@inject('appState')
export class ChangeLanguageButtonContainer extends React.Component<
    ChangeLanguageButtonContainerProps
> {
    /**
     * Navigate to version of page with other language on language button click
     */
    onClick = (): void => {
        const newPathName = location.pathname.replace(
            `/${getLangFromUrlPathname()}/`,
            `/${translate('other_canada_lang_abbreviation')}/`
        );

        const url = location.origin + '/' + newPathName + location.search;

        location.pathname = newPathName;
    };

    render() {
        return <ChangeLanguageButtonView onClick={this.onClick} />;
    }
}
